import React from "react"

export default function Container({children, classes, rowclasses})
{       
    const c = classes !== undefined ? ' '+classes : ''
    const r = rowclasses !== undefined ? ' '+rowclasses : ''
    
    return (
        <div className={"container"+c}>
            <div className={"row"+r}>
                {children}
            </div>      
        </div>
    ) 
}